export default __webpack_public_path__ + "static/pnews_1-2df9b0734f252e3ce33afdfbc580f150.jpg";